module.exports = {
  SITE_LOCATION: 'https://thepopulationproject.org',
};
